/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import LoadingSkeleton from 'bundles/grading/components/common/LoadingSkeleton';
import { panelExpandedWidthPx } from 'bundles/grading/components/layout/LeftPanel';

const styles = {
  container: css`
    display: block;
    width: ${panelExpandedWidthPx}px;
    height: 100%;
    padding: 0 var(--cds-spacing-200);
    overflow: hidden;
    mask-image: linear-gradient(to bottom, #000 50%, transparent 100%);
  `,
  gradingFlowTitleLazyLoad: css`
    margin: var(--cds-spacing-200) 0;
  `,
  gradedProgressBarLazyLoad: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  submitterLazyLoad: css`
    margin-bottom: var(--cds-spacing-50);
  `,
};

const numOfLazyLoadSubmitters = 15;

// Container for SGA left panel related components
const SGALazyLoadLeftPanel = () => {
  return (
    <div css={styles.container}>
      <LoadingSkeleton width="100px" height="24px" cssOverride={styles.gradingFlowTitleLazyLoad} />
      <LoadingSkeleton width="100%" height="24px" cssOverride={styles.gradedProgressBarLazyLoad} />
      {[...Array(numOfLazyLoadSubmitters)].map((_item, index) => (
        <LoadingSkeleton
          width="100%"
          height="48px"
          cssOverride={styles.submitterLazyLoad}
          // static list, warning can be ignored
          // eslint-disable-next-line react/no-array-index-key
          key={`submitter-lazy-load-${index}`}
        />
      ))}
    </div>
  );
};

export default SGALazyLoadLeftPanel;
